/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';

import {sortBy} from '../../../../shared/commonFunctions';
import {formatIndian} from '../../../../utils/formatIndian';
import RadialChartProps from '../interfaces/RadialChartProps';

const RadialCustomizedLegend: React.FC<{data: RadialChartProps[]}> = ({
  data
}) => {
  const [mainData, setMainData] = useState<any[]>([]);

  useEffect(() => {
    setMainData(sortBy(data, 'value'));
  }, [data]);

  return (
    <>
      <ul
        className="recharts-default-legend"
        style={{
          padding: '0px',
          margin: '0px',
          textAlign: 'left',
          height: 'fit-content'
        }}
      >
        {mainData?.map((e, index: number) => {
          return e.name ? (
            <li
              style={{
                display: 'flex',
                marginBottom: '10px'
              }}
              key={index}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <span
                  style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: `${e.fill}`,
                    borderRadius: '50%',
                    marginRight: '5px'
                  }}
                />
                <span
                  className="recharts-legend-item-text"
                  style={{
                    color: '#677489',
                    font: 'normal normal 600 12px/15px Montserrat'
                  }}
                >
                  {`${e.name} 
                (${formatIndian(e.value)})`}
                </span>
              </div>
            </li>
          ) : (
            <div key={index}></div>
          );
        })}
      </ul>
    </>
  );
};

export default RadialCustomizedLegend;
